<template>
  <div>
    <loading
      :active.sync="isLoading"
      :can-cancel="true"
      :on-cancel="onCancel"
      :is-full-page="fullPage"
    ></loading>
    <tabs :fullWidth="true">
      <tab name="Appearance" :selected="true">
        <div class="container-fluid container--no-margin">
          <div class="row">
            <div class="col-xs-12 col-sm-12 col-lg-12">
              <div class="content">
                <div class="container-fluid container--no-margin">
                  <div class="row">
                    <div
                      class="col-xs-12 col-sm-12 col-lg-4 container--no-margin"
                    >
                      <div class="page-editor--side">
                        <div>
                          <div
                            class="page-editor--side-item-content page-editor--side-item-content-active page-editor--side-item-content-active-top"
                          >
                            <div class="page-info--wrapper">
                              <div class="page--title">
                                {{ page.name }}
                              </div>
                              <div class="page--link">
                                <div v-if="page.enabled" class="page--status-on"></div>
                                <div v-else class="page--status-off"></div>
                                <div class="page--url">
                                  <a
                                    :href="
                                      'https://demoinbox.com/' + page.customUrl
                                    "
                                    target="_blank"
                                  >
                                    demoinbox.com/{{ page.customUrl
                                    }}<svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      height="11px"
                                      stroke="currentColor"
                                      stroke-width="2.5"
                                      stroke-linecap="round"
                                      stroke-linejoin="round"
                                      class="feather feather-external-link"
                                    >
                                      <path
                                        d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"
                                      ></path>
                                      <polyline
                                        points="15 3 21 3 21 9"
                                      ></polyline>
                                      <line
                                        x1="10"
                                        y1="14"
                                        x2="21"
                                        y2="3"
                                      ></line></svg
                                  ></a>
                                </div>
                              </div>
                            </div>
                            <div class="switch--wrapper">
                              <input
                                id="checkbox"
                                type="checkbox"
                                class="checkbox"
                                v-model="editted.enabled"
                              />
                              <label for="checkbox" class="switch">
                                <span class="switch__circle">
                                  <span class="switch__circle-inner"></span>
                                </span>
                              </label>
                            </div>
                          </div>
                        </div>
                        <div>
                          <div
                            class="page-editor--side-item"
                            v-on:click="expand($event)"
                          >
                            Information
                            <div class="chevron">
                              <svg
                                style="width: 24px; height: 24px"
                                viewBox="0 0 24 24"
                              >
                                <path
                                  fill="currentColor"
                                  d="M7.41,8.58L12,13.17L16.59,8.58L18,10L12,16L6,10L7.41,8.58Z"
                                />
                              </svg>
                            </div>
                          </div>
                          <div class="page-editor--side-item-content">
                            <div class="page-editor--label">Page Title</div>
                            <input
                              type="text"
                              placeholder="Page Title"
                              v-model="editted.title"
                              name="title"
                              class="input--text email login--input-bottom"
                            />
                            <div class="page-editor--label">Description</div>
                            <textarea
                              type="text"
                              placeholder="Description"
                              name="title"
                              v-model="editted.description"
                              class="input--text email login--input-bottom input--textarea"
                            ></textarea>
                          </div>
                        </div>
                        <div>
                          <div
                            class="page-editor--side-item"
                            v-on:click="expand($event)"
                          >
                            Colors
                            <div class="chevron">
                              <svg
                                style="width: 24px; height: 24px"
                                viewBox="0 0 24 24"
                              >
                                <path
                                  fill="currentColor"
                                  d="M7.41,8.58L12,13.17L16.59,8.58L18,10L12,16L6,10L7.41,8.58Z"
                                />
                              </svg>
                            </div>
                          </div>
                          <div class="page-editor--side-item-content">
                            <div class="page-editor--label">Primary Color {{ editted.primaryColor }}</div>
                            <picker :value="editted.primaryColor" v-model="editted.primaryColor"></picker>
                            <div class="page-editor--label">
                              Secondary Color {{ editted.secondaryColor }}
                            </div>
                            <picker v-model="editted.secondaryColor"></picker>
                            
                            <div class="page-editor--label">Text Color {{ editted.textColor }}</div>
                            <picker
                              v-on:change="test($event)"
                              v-model="editted.textColor"
                            ></picker>
                          </div>
                        </div>
                        <div>
                          <div
                            class="page-editor--side-item"
                            v-on:click="expand($event)"
                          >
                            Branding
                            <div class="chevron">
                              <svg
                                style="width: 24px; height: 24px"
                                viewBox="0 0 24 24"
                              >
                                <path
                                  fill="currentColor"
                                  d="M7.41,8.58L12,13.17L16.59,8.58L18,10L12,16L6,10L7.41,8.58Z"
                                />
                              </svg>
                            </div>
                          </div>
                          <div class="page-editor--side-item-content">
                            <div class="page-editor--label">Logo</div>
                            <div
                              class="page-editor--logo"
                              id="preview--logo"
                              v-bind:style="{
                                'background-image':
                                  'url(' + editted.logoUrl + ')',
                              }"
                            ></div>
                           <input type="file" @change="changeAssets($event, 'logo')" accept="image/*" id="file-logo">
                            <br>
                            <div class="page-editor--label">Background</div>
                            <div
                              class="page-editor--background"
                              id="preview--background"
                              v-bind:style="{
                                'background-image':
                                  'url(' + editted.backgroundUrl + ')',
                              }"
                            ></div>
                            <input type="file" @change="changeAssets($event, 'background')" accept="image/*" id="file-background">
                          </div>
                        </div>
                        <div>
                          <div
                            class="page-editor--side-item-content page-editor--side-item-content-active page-editor--side-item-content-active-bottom"
                          >
                            <div
                              class="btn page-editor--publish"
                              @click="publish()"
                            >
                              Publish
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      class="col-xs-12 col-sm-12 col-lg-8 container--no-margin"
                    >
                      <div
                        class="page-editor--page-wrapper"
                        id="preview--form-background"
                        v-bind:style="{
                          'background-image':
                            'url(' + editted.backgroundUrl + ')',
                        }"
                      >
                        <div class="page-editor--page">
                          <div class="container container--no-margin">
                            <div class="row">
                              <div class="col-xs-12 col-sm-12 col-lg-1"></div>
                              <div class="col-xs-12 col-sm-12 col-lg-10">
                                <div class="page--form">
                                  <div
                                    class="page-logo"
                                    id="preview--form-logo"
                                    v-bind:style="{
                                      'background-image':
                                        'url(' + editted.logoUrl + ')',
                                    }"
                                  ></div>
                                  <div class="page--title">
                                    {{ editted.title }}
                                  </div>
                                  <div>
                                    <p class="page--description"          v-bind:style="{
                                     color: editted.textColor,
                                   }" v-html="editted.description.replace(new RegExp('\r?\n','g'), '<br />')">
                                   </p>
                                  </div>
                                  <hr />
                                  <div class="page-editor--label">
                                    Artist Name
                                  </div>
                                  <input
                                    type="text"
                                    placeholder="Lukas Red"
                                    name="title"
                                    class="input--text email login--input-bottom"
                                  />
                                  <div class="page-editor--label">
                                    Track Title
                                  </div>
                                  <input
                                    type="text"
                                    placeholder="Live The Moment"
                                    name="title"
                                    class="input--text email login--input-bottom"
                                  />
                                  <div class="page-editor--label">Email</div>
                                  <input
                                    type="text"
                                    placeholder="lukasred@deepwinder.com"
                                    name=""
                                    class="input--text email login--input-bottom"
                                  />
                                  <hr />
                                  <div class="page-editor--label">
                                    Soundcloud URL
                                  </div>
                                  <input
                                    type="text"
                                    placeholder="https://soundcloud.com/trackname"
                                    name=""
                                    class="input--text email login--input-bottom"
                                  />
                                  <hr />
                                  <button
                                    class="btn btn-primary login--button-main"
                                    v-bind:style="{
                                      backgroundColor: editted.primaryColor,
                                    }"
                                  >
                                    Send Demos
                                  </button>
                                </div>
                              </div>
                              <div class="col-xs-12 col-sm-12 col-lg-1"></div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </tab>
      <tab name="Analytics"> </tab>
      <tab name="Settings"> </tab>
    </tabs>
  </div>
</template>

<script>
import axios from "axios";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import Tabs from "../components/Tabs";
import Tab from "../components/Tab";
import ColorPicker from "../components/ColorPicker";

export default {
  name: "contesteditor",
  components: {
    Loading,
    Tabs,
    Tab,
    picker: ColorPicker,
  },
  data() {
    return {
      page_id: this.$route.params.id,

      isLoading: false,
      fullPage: true,

      page: null,
      editted: null,
    };
  },
  mounted() {
    this.getPage();
  },
  methods: {
    getPage() {
      var self = this;
      this.isLoading = true;
      axios({
        method: "GET",
        crossdomain: true,
        headers: { "Content-Type": "Content-Type:application/json" },
        url: "https://api.demobottle.com/demo/page/" + self.page_id,
      })
        .then(function (response) {
          self.page = response.data;
          self.editted = self.trueCopy(self.page);
          self.isLoading = false;
          console.log(self.page);
        })
        .catch(function (error) {
          self.errors = error.response.data;
          self.isLoading = false;
        });
        
        console.log("page object");
        console.log(this.editted);
    },
    expand(event) {
      console.log(event.target.parentNode.children[1]);
      if (
        !event.target.parentNode.children[1].classList.contains(
          "page-editor--side-item-content-active"
        )
      ) {
        event.target.parentNode.children[1].classList.add(
          "page-editor--side-item-content-active"
        );
        event.target.parentNode.children[0].children[0].classList.add("active");
      } else {
        event.target.parentNode.children[1].classList.remove(
          "page-editor--side-item-content-active"
        );
        event.target.parentNode.children[0].children[0].classList.remove(
          "active"
        );
      }
    },
    clipboard(evt) {
      evt.preventDefault();
      navigator.clipboard.writeText(evt.target.getAttribute("href")).then(
        () => {
          /* clipboard successfully set */
        },
        () => {
          /* clipboard write failed */
        }
      );
    },
    trueCopy(o) {
      return Object.assign(new Object(), o);
    },      
    changeAssets(event, type){
      var file = event.target.files[0];
      var reader = new FileReader();
      if(type == "logo"){
        reader.onloadend = function () {
          document.getElementById("preview--logo").style.backgroundImage = 'url("' + reader.result + '")';
          document.getElementById("preview--form-logo").style.backgroundImage = 'url("' + reader.result + '")';
        }
        if (file) {
            reader.readAsDataURL(file);
        } else {
          console.log("no file");
        }
        
      }else{
        reader.onloadend = function () {
          document.getElementById("preview--background").style.backgroundImage = 'url("' + reader.result + '")';
          document.getElementById("preview--form-background").style.backgroundImage = 'url("' + reader.result + '")';
        }
        if (file) {
            reader.readAsDataURL(file);
        } else {
          console.log("no file");
        }
      }
      
    },
    uploadAssets() {
      var formData = new FormData();
      var logo = document.querySelector('#file-logo');
      var background = document.querySelector('#file-background');
      console.log(logo);
      console.log(background);
      this.isLoading = true;
      var self = this;
      formData.append("organization_id", this.$globals.organization_id);
      
      if (logo.files[0]){
        formData.append("logoImage",  logo.files[0]);
      }
      
      if (background.files[0]){
        formData.append("backgroundImage",  background.files[0]);
      }
    
      formData.append("enabled", this.editted.enabled);
      
      axios.post("https://api.demobottle.com/demo/page/" + self.editted.customUrl, formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
      })        
      .then(function (response) {
        console.log(response);
        self.$globals.getPages();
        self.isLoading = false;
      });
    },
    publish() {
      let self = this;
      this.isLoading = true;
      this.uploadAssets();
      axios({
        method: "POST",
        crossdomain: true,
        headers: { "Content-Type": "Content-Type:application/json" },
        url: "https://api.demobottle.com/demo/page/" + self.editted.customUrl,
        data: self.editted,
      })
        .then(function (response) {
          console.log(response);
          self.isLoading = false;
          self.getPage();
          self.$globals.getPages();
        })
        .catch(function (error) {
          self.errors = error.response.data;
          self.isLoading = false;
        });
    },
    test(e) {
      console.log(e);
    },
  },
};
</script>